{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "form_assistant",
  "x-feature": true,
  "x-tier": "advanced",
  "title": "Form Assistant",
  "description": "Copilot mode: search bar on form pages to help visitors fill forms.",
  "type": "object",
  "properties": {
    "pages": {
      "ui:sectionTitle": "Assisted Pages",
      "ui:sectionDescription": "Pages where the form assistant runs.",
      "ui:sectionIcon": "FileText",
      "type": "object",
      "ui:widget": "form-assistant-pages",
      "ui:description": "Pages where copilot mode activates, with questions to display. Most specific matching pattern wins. To match query params or hashes, include ? or # explicitly in the pattern.",
      "additionalProperties": {
        "type": "array",
        "maxItems": 50,
        "items": {
          "type": "object",
          "properties": {
            "patterns": {
              "type": "array",
              "ui:description": "URL patterns to match. To match query params or hashes, include ? or # explicitly in the pattern.",
              "maxItems": 20,
              "items": {
                "type": "string"
              }
            },
            "questions": {
              "type": "array",
              "maxItems": 3,
              "minItems": 1,
              "items": {
                "type": "string",
                "maxLength": 500
              }
            }
          },
          "required": [
            "patterns",
            "questions"
          ]
        }
      }
    }
  },
  "default": {}
}
